import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { AVIS_VERIFIES_URL_REVIEWS, NUMBER_OF_REVIEWS } from '~/constants';
import { avisVerifiesTokens } from '~/helpers/reviewsRating';
export function useReviews() {
  var _useNuxt2App = useNuxt2App(),
    locale = _useNuxt2App.i18n.locale,
    $sentry = _useNuxt2App.$sentry;

  /**
   * Takes an array of raw review data and transforms it into a structured Reviews object format.
   */
  function transformReviews(reviewsData) {
    return reviewsData.map(function (review) {
      return {
        rating: review.rate,
        description: review.review,
        firstName: review.firstname,
        lastName: review.lastname,
        date: review.review_date,
        customerServiceResponse: review.moderation
      };
    });
  }

  /**
   * Fetches reviews for a specific product ID with pagination
   */
  function fetchReviews(_x, _x2) {
    return _fetchReviews.apply(this, arguments);
  }
  /**
   * Fetches average review data for a specific product ID (and optional locale).
   */
  function _fetchReviews() {
    _fetchReviews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(ids, offset) {
      var _results$, results;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return $fetch(AVIS_VERIFIES_URL_REVIEWS, {
              method: 'POST',
              body: JSON.stringify({
                idWebsite: avisVerifiesTokens[locale],
                query: 'reviews',
                order: 'date_desc',
                products: ids,
                limit: NUMBER_OF_REVIEWS,
                plateforme: locale,
                offset: (offset - 1) * 3
              })
            });
          case 3:
            results = _context.sent;
            return _context.abrupt("return", results ? transformReviews((_results$ = results[0]) === null || _results$ === void 0 ? void 0 : _results$.reviews) : null);
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.warn('[useReviews] - Could not deserialize reviews', _context.t0);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return _fetchReviews.apply(this, arguments);
  }
  function fetchAverageReviews(_x3, _x4) {
    return _fetchAverageReviews.apply(this, arguments);
  }
  /**
   * Fetches average review data for a specific product ID across all supported locales.
   */
  function _fetchAverageReviews() {
    _fetchAverageReviews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(ids, localeOpt) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return $fetch(AVIS_VERIFIES_URL_REVIEWS, {
              method: 'POST',
              body: JSON.stringify({
                idWebsite: avisVerifiesTokens[localeOpt !== null && localeOpt !== void 0 ? localeOpt : locale],
                query: 'average',
                products: ids,
                plateforme: localeOpt !== null && localeOpt !== void 0 ? localeOpt : locale
              }),
              redirect: 'follow'
            });
          case 3:
            return _context2.abrupt("return", _context2.sent);
          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2["catch"](0);
            console.warn('[useReviews] - Could not deserialize average reviews', _context2.t0);
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 6]]);
    }));
    return _fetchAverageReviews.apply(this, arguments);
  }
  function fetchAllAverageReviews(_x5) {
    return _fetchAllAverageReviews.apply(this, arguments);
  }
  function _fetchAllAverageReviews() {
    _fetchAllAverageReviews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(ids) {
      var results, responses, _iterator, _step, response, responseId, _item, resultId, item;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            results = {};
            _context3.next = 3;
            return Promise.all(Object.keys(avisVerifiesTokens).map(function (locale) {
              return fetchAverageReviews(ids, locale).then(function (result) {
                return result;
              });
            }));
          case 3:
            responses = _context3.sent;
            _iterator = _createForOfIteratorHelper(responses);
            _context3.prev = 5;
            _iterator.s();
          case 7:
            if ((_step = _iterator.n()).done) {
              _context3.next = 14;
              break;
            }
            response = _step.value;
            if (response) {
              _context3.next = 11;
              break;
            }
            return _context3.abrupt("continue", 12);
          case 11:
            for (responseId in response) {
              if (!results[responseId]) {
                results[responseId] = {
                  count: 0,
                  totalRate: 0
                };
              }
              _item = response[responseId][0];
              if (_item) {
                results[responseId].count += Number(_item.count);
                results[responseId].totalRate += Number(_item.rate) * Number(_item.count); // Multiply rate by count to get total
              }
            }
          case 12:
            _context3.next = 7;
            break;
          case 14:
            _context3.next = 19;
            break;
          case 16:
            _context3.prev = 16;
            _context3.t0 = _context3["catch"](5);
            _iterator.e(_context3.t0);
          case 19:
            _context3.prev = 19;
            _iterator.f();
            return _context3.finish(19);
          case 22:
            for (resultId in results) {
              item = results[resultId];
              item.averageRate = item.count ? item.totalRate / item.count : 0;
              delete item.totalRate;
            }
            return _context3.abrupt("return", results);
          case 24:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[5, 16, 19, 22]]);
    }));
    return _fetchAllAverageReviews.apply(this, arguments);
  }
  return {
    fetchReviews: fetchReviews,
    fetchAverageReviews: fetchAverageReviews,
    fetchAllAverageReviews: fetchAllAverageReviews
  };
}